<div class="p-4">
    <breadcrumb [items]="breadcrumb"></breadcrumb>

    <mat-spinner class="mx-auto my-5" *ngIf="loading.main"></mat-spinner>
    <mat-card *ngIf="!loading.main">
        <mat-card-content>
            <h1 class="fs-3 fw-light mb-3">Nova beneficiária frota Novacap</h1>
            <form class="row align-items-center" name="form" (ngSubmit)="form.valid && save()" #form="ngForm" novalidate>

                <div class="col-12">
                    <ng-select name="beneficiaria"  [items]="beneficiarias" required
                        [placeholder]="'Beneficiária'" [searchFn]="searchFn"
                        [(ngModel)]="beneficiaria" bindValue="id"
                        [loading]="loading.beneficiarias" [compareWith]="compareWith" (change)="setBeneficiaria($event)">
                        <!-- selected/list -->
                        <ng-template ng-label-tmp ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="d-flex align-items-center">
                                <span>{{ item.nome }}</span>
                                <div class="fs-7 opacity-50" style="margin-left: 10px;">{{ item.cnpj  | mask: 'CPF_CNPJ'}}</div>
                            </div>
                        </ng-template>
                        <!-- add item -->
                        <ng-template ng-tag-tmp let-search="searchTerm">
                            <div class="d-flex align-items-center pointer">
                                <mat-icon class="text-primary me-1">add_circle</mat-icon> 
                                <span class="text-primary me-1">Selecionar beneficiária:</span>
                                <span>{{ search }}</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>    

                <div class="col-12">
                    <hr class="border-gray mt-0">
                </div>
                <div class="col-12 col-md-auto ms-auto">
                    <button type="button" mat-button color="primary" class="btn-lg px-4" [routerLink]="['configuracoes', 'gerir-coligadas-novacap']"
                        [queryParams]="{ tab:'alocacao' }">VOLTAR</button>
                </div>
                <div class="col-12 col-md-3">
                    <button mat-flat-button color="primary" class="btn-lg w-100" [disabled]="form.form.invalid || loading.save">
                        <mat-spinner class="btn-spinner" *ngIf="loading.save"></mat-spinner>
                        <span *ngIf="!loading.save">SALVAR</span>
                    </button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</div>
